module.exports = __webpack_public_path__ + "static/media/doc.457a02b7.svg";